function getTarget(value) {
  return typeof value === 'string' ? document.querySelector(value) : value
}

export default {
  mounted(element, binding) {
    element.__scrollToTarget = binding.value
    element.__scrollToHandler = (event) => {
      event.preventDefault()
      const target = getTarget(element.__scrollToTarget)

      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      } else if (typeof element.__scrollToTarget === 'string' && element.__scrollToTarget.startsWith('#')) {
        window.location.assign(`/${element.__scrollToTarget}`)
      }
    }
    element.addEventListener('click', element.__scrollToHandler)
  },
  updated(element, binding) {
    element.__scrollToTarget = binding.value
  },
  unmounted(element) {
    element.removeEventListener('click', element.__scrollToHandler)
    delete element.__scrollToHandler
    delete element.__scrollToTarget
  }
}
